
import { Routes, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import dive from "../../assets/gido (13).jpg"
import dive16 from "../../assets/gido (20).jpg"
import kid4 from "../../assets/kid (1).jpg"
import Aos from 'aos';
import 'aos/dist/aos.css'
import { useEffect, useState } from "react";
import DiveCourses from './DiveCourses';
import KidsCourses from './KidsCourses';
import axios from 'axios';
import { useTranslation } from "react-i18next";


import { API_URL } from "../../config";

function Courses() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  });

  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const { t } = useTranslation();

  <Routes>
    <Route path="./DiveCourses" element={<DiveCourses />} />
    <Route path="./KidsCourses" element={<KidsCourses />} />

  </Routes>
  const [price, setPrice] = useState([]);
  useEffect(() => {
    async function getPrice() {
      try {
        const responce = await axios.get(`${API_URL}/prices`);
        setPrice(responce.data);
      }
      catch (error) {
        console.error(error)
      }
    } getPrice();
  }, []);

  return (
    <div>

      <div className="w-full h-full relative" data-aos="fade-up">
        <img src={dive} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center flex-col">
          <h1 data-aos="fade-right" className="text-white  text-2xl md:text-2xl font-bold">{t("siteName")} </h1>
          <h1 data-aos="fade-left" className="text-white  text-6xl md:text-6xl font-bold">{t("courses")} </h1>

        </div>
      </div>

      <Link to={"./DiveCourses"}>

        <div className="w-full mt-10 flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white rounded shadow">
          <div className='relative md:w-[40%] w-screen  '>
            <img src={dive16} data-aos="fade-left" className=" w-full h-full  object-cover rounded
      border-blue-300 flex-shrink-0 "/>
            <div className="absolute inset-0 flex  flex-col justify-center ">
              <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-center'>
                <h2 className="text-white  text-xl md:text-xl font-bold p-2">15 years</h2>
              </div>
            </div>

          </div>
          {price.filter((el) => el.id === "8").map((item) => (
            <div data-aos="fade-right" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left ml-4  flex flex-col justify-center flex-1
     overflow-auto px-6 ">
              <h2 className="md:text-4xl text-xl font-bold mb-2 text-gray-700">{t("course")} ${item.price} </h2>
              <p className="text-gray-700 md:font-bold ">
                {t("course1")}
              </p>
              <div className='flex flex-row w-full p-4 justify-between md:text-2xl font-bold mb-2 text-gray-600 '>
                <h3 >{t("course3")}</h3>
                <h3 >{t("course4")}</h3>

              </div>
            </div>))}
        </div>

      </Link>


      <Link to={"./KidsCourses"}>

        <div className=" w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white rounded shadow">
          <div className='relative md:w-[40%] w-screen   '>
            <img src={kid4} data-aos="fade-right" className=" w-full h-full  object-cover rounded
      border-blue-300 flex-shrink-0"/>
            <div className="absolute inset-0 flex  flex-col justify-center ">
              <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-left'>
                <h2 className="text-white  text-xl md:text-xl font-bold p-2">15 years</h2>
              </div>
            </div>
          </div>

          {price.filter((el) => el.id === "7").map((item) => (
            <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left ml-4 flex flex-col justify-center flex-1 overflow-auto px-6">
              <h2 className="md:text-4xl text-xl font-bold mb-2 text-gray-700">{t("kidcourse")} ${item.price} </h2>
              <p className="text-gray-700 md:font-bold">
                {t("kidcourse1")}
              </p>
              <div className='flex flex-row w-full p-4 justify-between md:text-2xl font-bold mb-2 text-gray-600 '>
                <h3 >{t("course3")}</h3>
                <h3 >{t("course4")}</h3>

              </div>
            </div>))}



        </div>

      </Link>



    </div>
  );
}
export default Courses;